import { IonContent, IonPage, IonSpinner } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import Header from '@facilities/components/Header/Header';
import TasksAlert from '@facilities/components/TasksAlert/TasksAlert';
import { FACILITIES_APP_POC_CARERS_WIDGET_URL } from '@facilities/constants/urlConstants';
import useGetFacility from '@facilities/hooks/useGetFacility';
import { formatFacilitiesAppPocWidgetUrl } from '@facilities/utils/utils-fn';
import pageStyles from '@facilities/views/Carers/Carers.module.css';
import containersStyles from '@facilities/views/containers.module.css';

const Carers = () => {
  const { t } = useTranslation('app', { keyPrefix: 'facilities' });

  const planningTitle = t('home.planning.title');

  const { facilityId } = useParams<{ facilityId: string }>();
  const { data: facility, isSuccess, isLoading } = useGetFacility(facilityId);

  const carersUrl = formatFacilitiesAppPocWidgetUrl(FACILITIES_APP_POC_CARERS_WIDGET_URL, {
    facilityId,
  });

  return (
    <IonPage>
      <Header title={t('common.menu.carers')} facility={facility} />
      {isLoading && <IonSpinner />}
      {isSuccess && (
        <IonContent className="ion-padding">
          <div className={containersStyles.fullWidthFlexContainer}>
            <TasksAlert />
            <div className={containersStyles.fullHeightFlexContainer}>
              <iframe
                title={planningTitle}
                className={`ion-padding ${pageStyles.facilitiesAppPocCarers}`}
                src={carersUrl}
                frameBorder="0"
              />
            </div>
          </div>
        </IonContent>
      )}
    </IonPage>
  );
};

export default Carers;
